export default __webpack_public_path__ + "eab9a3ace30a8a74cdefb40560c36ddb.svg";